import { v4 as uuidv4 } from 'uuid';

const processItemData = [
    {
        id: uuidv4(),
        number: '01',
        heading: 'Initial Consultation',
        text: 'We begin with a detailed discussion to understand your requirements, project scope, and technical specifications to ensure alignment with your vision.',
    },

    {
        id: uuidv4(),
        number: '02',
        heading: 'Design & Development',
        text: 'Our expert team creates detailed CAD designs, 3D models, and prototypes using cutting-edge technology to bring your concept to life.',
    },

    {
        id: uuidv4(),
        number: '03',
        heading: 'Testing & Refinement',
        text: 'Rigorous testing and quality assurance procedures ensure your product meets all specifications, standards, and performance requirements.',
    },

    {
        id: uuidv4(),
        number: '04',
        heading: 'Delivery & Support',
        text: 'Final product delivery with comprehensive documentation and ongoing technical support to ensure successful implementation and operation.',
    },
];

export default processItemData;
